import { Component, Input, ElementRef, Inject } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcComponent, FCSIZE } from '../fc';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
/**
 * fc-backtopåå°é¡¶é¨
 * 
 * è¿åé¡µé¢é¡¶é¨çæä½æé®ã
 * 
 * å½é¡µé¢åå®¹åºåæ¯è¾é¿æ¶ã
 * 
 * å½ç¨æ·éè¦é¢ç¹è¿åé¡¶é¨æ¥çç¸å³åå®¹æ¶ã
 * 
 */
@Component({
    selector: 'fc-backtop',
    /**
     * @ignore
     */
    template: `
        <div class="long-div" #divTarget>
            <div class="long-div-inner">
                <div class="fc-header">
                <ng-content select="[fcheader]"></ng-content>
            </div>  
            <div class="fc-toolbar">
                <ng-content select="[fctoolbar]"></ng-content>
            </div>      
            <div class="fc-content">
                <ng-content select="[fccontent]"></ng-content>
            </div>
            <div class="fc-footer">
                <ng-content select="[fcfooter]"></ng-content>
            </div>
            </div>
        <nz-back-top [nzTarget]="divTarget"  [nzVisibilityHeight]="_visibility"></nz-back-top>
     </div>
    `,
    styles: [`
    `]
})
export class FcbacktopComponent extends FcComponent {
     /** æ é¢*/
    @Input()
    fcLabel: string;
     /**æ»å¨å°ä¸å®é«åº¦åºç°*/
     @Input()
     fcVisibilityHeight:string;
     _visibility:number;
    @Input()
    element1: any = null;
    constructor(public provider: ProvidersService, public elementRef: ElementRef, @Inject(DOCUMENT) doc: any, public router: Router) {
        super(provider, 'fc-backtop');
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
         /**å¦ææå¼è¶åºè¿ä¸ªèå´åºç°æ»å¨è½´*/
        if(this.fcVisibilityHeight!==undefined){
            this._visibility = parseInt(this.fcVisibilityHeight)
        }
    }
    ngAfterViewInit() {  /** æ¨¡æ¿ä¸­çåç´ å·²åå»ºå®æ*/
    }
}
export interface FcbacktopOption {
    label?: string;
    href?: string;
}
